import { isValidCnpj } from "./cnpj.js";
import { normalizePhoneBR } from "./phone.js";
import { isValidSlug } from "./slug.js";
const CEP_RE = /^\d{5}-?\d{3}$/;
const UF_RE = /^[A-Z]{2}$/;
/**
 * Trava de publicação — checklist §4 do PDF (ADR-025).
 * Enquanto `ok` for `false`, o painel não deixa setar `status = "published"`.
 * Campos opcionais (licença sanitária/AFE, fotos, serviços, cor, email) não entram.
 */
export function checkPublishReady(f) {
    const issues = [];
    const req = (cond, field, message) => {
        if (!cond)
            issues.push({ field, message });
    };
    req(isValidSlug(f.slug), "slug", "Slug inválido ou reservado.");
    req(f.razaoSocial.trim().length >= 2, "razaoSocial", "Razão social é obrigatória.");
    req(f.nomeFantasia.trim().length >= 2, "nomeFantasia", "Nome fantasia é obrigatório.");
    req(f.cnpjs.length >= 1, "cnpjs", "Informe ao menos um CNPJ.");
    for (const [i, cnpj] of f.cnpjs.entries()) {
        req(isValidCnpj(cnpj), `cnpjs.${i}`, `CNPJ ${cnpj || i + 1}: dígito verificador não confere.`);
    }
    const e = f.endereco;
    req(!!e.logradouro?.trim(), "endereco.logradouro", "Logradouro é obrigatório.");
    req(!!e.numero?.trim(), "endereco.numero", "Número é obrigatório.");
    req(!!e.bairro?.trim(), "endereco.bairro", "Bairro é obrigatório.");
    req(!!e.cidade?.trim(), "endereco.cidade", "Cidade é obrigatória.");
    req(UF_RE.test(e.uf ?? ""), "endereco.uf", "UF deve ter 2 letras.");
    req(CEP_RE.test(e.cep ?? ""), "endereco.cep", "CEP inválido (use 00000-000).");
    req(normalizePhoneBR(f.telefoneComercial) !== null, "telefoneComercial", "Telefone comercial inválido.");
    req(normalizePhoneBR(f.whatsapp) !== null, "whatsapp", "WhatsApp inválido (DDD + número).");
    req(f.farmaceuticos.length >= 1, "farmaceuticos", "Informe ao menos um farmacêutico responsável.");
    for (const [i, farmaceutico] of f.farmaceuticos.entries()) {
        const quem = farmaceutico.nome.trim() || `responsável ${i + 1}`;
        req(farmaceutico.nome.trim().length >= 2, `farmaceuticos.${i}.nome`, `Nome do ${i + 1}º farmacêutico responsável é obrigatório.`);
        req(farmaceutico.crf.trim().length >= 2, `farmaceuticos.${i}.crf`, `Informe o CRF de ${quem}.`);
    }
    req(f.horarios.length >= 1, "horarios", "Informe ao menos um horário de funcionamento.");
    for (const [i, h] of f.horarios.entries()) {
        req(h.abre < h.fecha, `horarios.${i}`, `Horário de ${h.dia}: abertura deve ser antes do fechamento.`);
    }
    req(f.logo !== null, "logo", "Logo (PNG ou SVG) é obrigatório.");
    if (f.logo) {
        const ok = /image\/(png|svg\+xml)/.test(f.logo.contentType) || /\.(png|svg)$/i.test(f.logo.path);
        req(ok, "logo", "Logo deve ser PNG ou SVG.");
    }
    return { ok: issues.length === 0, issues };
}
//# sourceMappingURL=publish-checklist.js.map